import { render, staticRenderFns } from "./ProductSetting.vue?vue&type=template&id=2fd9f320&scoped=true&"
import script from "./ProductSetting.vue?vue&type=script&lang=js&"
export * from "./ProductSetting.vue?vue&type=script&lang=js&"
import style0 from "./ProductSetting.vue?vue&type=style&index=0&id=2fd9f320&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd9f320",
  null
  
)

export default component.exports